import { ReactComponent as PopOut } from 'assets/icons/icon-popout.svg';

export default PopOut;
